document.addEventListener("DOMContentLoaded", () => {

    const slider = document.querySelector(".lb-dresses-swiper");

    if (!slider) return;

    const wrapper = slider.querySelector(".swiper-wrapper");
    const slides = [...wrapper.querySelectorAll(".swiper-slide")];

    const prev = document.querySelector(".lb-prev");
    const next = document.querySelector(".lb-next");

    let index = 0;
    let autoPlay;
    let userInteracted = false;

    function gap(){

        if(window.innerWidth <= 767) return 14;

        if(window.innerWidth <= 1024) return 18;

        return 20;

    }

    function activeIndex(){

        return index;

    }

    function updateActive(){

        slides.forEach(slide=>{

            slide.classList.remove("lb-active");

        });

        if(slides[index]){

            slides[index].classList.add("lb-active");

        }

    }

    function update(){

        const slide = slides[index];

        if(!slide) return;

        const sliderWidth = slider.offsetWidth;

        const slideWidth = slide.offsetWidth;

        const slideLeft = slide.offsetLeft;

        const translate =
            slideLeft - ((sliderWidth - slideWidth) / 2);

        wrapper.style.transform =
            `translate3d(-${translate}px,0,0)`;

        updateActive();

    }

    function nextSlide(){

        index++;

        if(index >= slides.length){

            index = 0;

        }

        update();

    }

    function prevSlide(){

        index--;

        if(index < 0){

            index = slides.length - 1;

        }

        update();

    }

    function stopAuto(){

        userInteracted = true;

        clearInterval(autoPlay);

    }

    function restartAuto(){

        if(userInteracted) return;

        clearInterval(autoPlay);

        autoPlay = setInterval(nextSlide,3500);

    }

    next.addEventListener("click",()=>{

        stopAuto();

        nextSlide();

    });

    prev.addEventListener("click",()=>{

        stopAuto();

        prevSlide();

    });

    let startX = 0;

    wrapper.addEventListener("touchstart",(e)=>{

        startX = e.touches[0].clientX;

        stopAuto();

    });

    wrapper.addEventListener("touchend",(e)=>{

        const endX = e.changedTouches[0].clientX;

        const diff = startX - endX;

        if(diff > 60){

            nextSlide();

        }

        if(diff < -60){

            prevSlide();

        }

    });

    slider.addEventListener("mouseenter",()=>{

        stopAuto();

    });

    window.addEventListener("resize",update);

    update();

    restartAuto();

});